// extracted by mini-css-extract-plugin
export default {"content":"style_content__74cj8","emails":"style_emails__hqQSW"};